import { CommonModule } from "@angular/common";
import { AfterContentInit, Component, ContentChildren, Input, NgModule, QueryList, TemplateRef, ViewEncapsulation } from "@angular/core";
import { ReactiveFormsModule, FormsModule, FormGroup } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { RouterModule } from "@angular/router";

@Component({
    selector: 'app-stepper-wrapper',
    template: `<div class="stepper-wrapper">
    <mat-horizontal-stepper [linear]="false" #stepper>
      <ng-container *ngFor="let step of steps">
        <mat-step [stepControl]="step.formGroup">
          <form [formGroup]="step.formGroup">
            <ng-template matStepLabel>{{ step.label }}</ng-template>
            <div class="step-content">

                    <ng-container *ngTemplateOutlet="step.content"></ng-container>
            </div>
            <div class="step-buttons">
              <button mat-button *ngIf="stepper.selectedIndex > 0" matStepperPrevious>Previous</button>
              <button mat-button *ngIf="stepper.selectedIndex < steps.length - 1" matStepperNext>Next</button>
              <button mat-button *ngIf="stepper.selectedIndex === steps.length - 1" (click)="onSubmit()">Submit</button>
            </div>
          </form>
        </mat-step>
      </ng-container>
    </mat-horizontal-stepper>
  </div>`,
    styles:`.stepper-w
      .mat-horizontal-stepper-header-container {
        height: 72px; /* Default height for horizontal stepper header */
      }
      
    
.step-content {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 56px; /* Ensure space for buttons */
}
   
    .step-buttons {
        display: flex;
        justify-content: flex-end;
        position: sticky;
        bottom: 0;
        width: 100%;
        padding: 16px;
        background-color: #fff;
        box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
        z-index: 1; /* Ensure the buttons stay above the content */
    }
      
      `,
    encapsulation: ViewEncapsulation.None
  })
  export class StepperWrapperComponent implements AfterContentInit {
    @Input() steps: { label: string, formGroup: FormGroup, content: TemplateRef<any> | null }[] = [];
  
    @ContentChildren(TemplateRef) contentTemplates!: QueryList<TemplateRef<any>>;
  
    ngAfterContentInit() {
      this.steps.forEach((step, index) => {
        step.content = this.contentTemplates.toArray()[index];
      });
    }
  
    onSubmit() {
      // Handle submit logic here
      console.log('Form submitted!');
    }
  }

  @NgModule({
    imports:  [
      CommonModule,
      RouterModule,
      MatStepperModule,
      MatCheckboxModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      FormsModule,
      MatSelectModule,
      MatInputModule,
      
    ],
    declarations: [ StepperWrapperComponent ],
    exports: [ StepperWrapperComponent ]
  })
  export class WrapperStepperModule { }